module.exports = __webpack_public_path__ + "static/media/icon-smile.20cb1a4d.svg";